






































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeCpCompliance } from "@/store/modules/CpComplianceStore";
import CpComplianceSvc from "@/services/CpComplianceService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";

const KOMPONEN_ORDER = ["terapi", "penunjang", "los", "tindakan", "diet", "edukasi"];

const KOMPONEN_LABELS: any = {
  terapi: "1. Terapi / Obat-obatan",
  penunjang: "2. Pemeriksaan Penunjang (Lab, Radiologi, dll.)",
  los: "3. LOS (Lama Rawat)",
  tindakan: "4. Tindakan / Prosedur",
  diet: "5. Diet / Nutrisi",
  edukasi: "6. Edukasi Pasien",
};

@Component({ components: { UnitRuangPicker, VCDateTimePicker } })
export default class CpComplianceForm extends Vue {
  @Prop({ default: null }) sessionData!: any;

  storeModule = storeCpCompliance;
  session: any = null;
  saving = false;
  signing = false;
  showSignDialog = false;
  signPassword = "";
  komponenLabels = KOMPONEN_LABELS;
  warningSnackbar = false;
  warningMessage = "";

  // Picker "Pilih Pasien" (Ranap)
  showPicker = false;
  pickerLoading = false;
  pickingId: any = null;
  candidates: any[] = [];
  pickerFilter: any = { date_from: "", date_to: "", unit: null, search: "" };
  pickerHeaders = [
    { text: "Tgl Masuk", value: "tgl_masuk", width: "110px" },
    { text: "Pasien", value: "pasien_nama" },
    { text: "DPJP", value: "dpjp_nama", width: "160px" },
    { text: "Ruang", value: "unit_nama", width: "150px" },
    { text: "", value: "actions", sortable: false, width: "70px" },
  ];

  // Persentase kesesuaian: default otomatis dari 6 komponen, boleh di-override
  persentaseManual = false;

  form: any = {
    cp_definition_id: null,
    register_id: null,
    pasien_rm: "",
    pasien_nama: "",
    dpjp_id: null,
    dpjp_nama: "",
    unit_id: "",
    departemen_smf: "",
    tgl_evaluasi: moment().format("YYYY-MM-DD"),
    tgl_masuk: "",
    tgl_keluar: "",
    diagnosis_icd10_kode: "",
    diagnosis_icd10_uraian: "",
    persentase_kesesuaian: null,
    is_eksklusi: false,
    varian_alasan: "",
    jenis_varian: null,
    analisa_penyebab: [],
    penyebab_lainnya: "",
    rencana_tindak_lanjut: "",
  };

  items: any[] = KOMPONEN_ORDER.map(k => ({
    komponen: k,
    standar_cp: "",
    realisasi_temuan: "",
    status_komponen: null,
    keterangan_varian: "",
  }));

  rules = {
    required: (v: any) => !!v || "Wajib diisi",
  };

  analisaPenyebabOptions: any = {
    kondisi_klinis_pasien_tidak_memungkinkan: "Kondisi klinis pasien tidak memungkinkan",
    permintaan_pasien_keluarga: "Permintaan pasien / keluarga",
    obat_alat_tidak_tersedia: "Obat / alat tidak tersedia",
    pasien_pulang_aps: "Pasien pulang atas permintaan sendiri (APS)",
    pasien_meninggal: "Pasien meninggal dalam perawatan",
    perubahan_diagnosis: "Perubahan diagnosis selama rawat inap",
    komorbiditas_mempengaruhi: "Komorbiditas yang mempengaruhi perjalanan klinis",
    lainnya: "Lainnya",
  };

  jenisVarianOptions = [
    { text: "Klinis", value: "klinis" },
    { text: "Manajerial", value: "manajerial" },
    { text: "Sistem", value: "sistem" },
  ];

  get tglEvaluasiDate(): Date | null {
    return parseLocalDate(this.form.tgl_evaluasi);
  }

  set tglEvaluasiDate(val: Date | null) {
    this.form.tgl_evaluasi = val ? localISODate(val) : "";
  }

  get tglMasukDate(): Date | null {
    return parseLocalDate(this.form.tgl_masuk);
  }

  set tglMasukDate(val: Date | null) {
    this.form.tgl_masuk = val ? localISODate(val) : "";
  }

  get tglKeluarDate(): Date | null {
    return parseLocalDate(this.form.tgl_keluar);
  }

  set tglKeluarDate(val: Date | null) {
    this.form.tgl_keluar = val ? localISODate(val) : "";
  }

  get pickerDateFrom(): Date | null {
    return parseLocalDate(this.pickerFilter.date_from);
  }

  set pickerDateFrom(val: Date | null) {
    this.pickerFilter.date_from = val ? localISODate(val) : "";
  }

  get pickerDateTo(): Date | null {
    return parseLocalDate(this.pickerFilter.date_to);
  }

  set pickerDateTo(val: Date | null) {
    this.pickerFilter.date_to = val ? localISODate(val) : "";
  }

  get cpOptions() {
    return this.storeModule.definitions.map((d: any) => ({
      text: `${d.kode} — ${d.nama_pathway}`,
      value: d.id,
    }));
  }

  get departemenSmfOptions() {
    const meta = this.storeModule.definitionsMeta;
    if (!meta || !meta.departemen_smf_options) return [];
    return Object.entries(meta.departemen_smf_options).map(([value, text]) => ({ value, text }));
  }

  get numerator() {
    return this.items.filter((i: any) => i.status_komponen === "sesuai").length;
  }

  get totalEvaluated() {
    return this.items.filter((i: any) => i.status_komponen !== null).length;
  }

  get computedKepatuhan() {
    if (this.form.is_eksklusi) {
      return { label: "EKSKLUSI", color: "grey", alertType: "info" };
    }
    const tidakSesuai = this.items.filter((i: any) => i.status_komponen === "tidak_sesuai").length;
    const sesuai = this.numerator;
    if (this.totalEvaluated < 6) return null;
    if (tidakSesuai > 0) {
      return { label: "TIDAK PATUH", color: "red", alertType: "error" };
    }
    if (sesuai === 6) {
      return { label: "PATUH", color: "green", alertType: "success" };
    }
    return null;
  }

  get showSectionD() {
    // Show when any item is tidak_sesuai OR is_eksklusi is true
    return this.items.some((i: any) => i.status_komponen === "tidak_sesuai") || this.form.is_eksklusi;
  }

  get conditionalRule() {
    // Used on fields inside Section D. If tidak_patuh & not eksklusi, require.
    const hasTidak = this.items.some((i: any) => i.status_komponen === "tidak_sesuai");
    if (hasTidak && !this.form.is_eksklusi) {
      return [this.rules.required];
    }
    return [];
  }

  get computedLos() {
    if (!this.form.tgl_masuk || !this.form.tgl_keluar) return "";
    const masuk = moment(this.form.tgl_masuk);
    const keluar = moment(this.form.tgl_keluar);
    const diff = keluar.diff(masuk, "days");
    return diff >= 0 ? diff : "";
  }

  // Persentase otomatis = (komponen Sesuai / 6) × 100 (selaras backend recomputeCompliance)
  get autoPersentase() {
    return Math.round((this.numerator / 6) * 1000) / 10;
  }

  @Watch("autoPersentase")
  onAutoPersentaseChange(val: number) {
    if (!this.persentaseManual) {
      this.form.persentase_kesesuaian = val;
    }
  }

  resetPersentaseAuto() {
    this.persentaseManual = false;
    this.form.persentase_kesesuaian = this.autoPersentase;
  }

  async mounted() {
    await this.storeModule.loadDefinitions();
    if (this.sessionData?.id) {
      await this.storeModule.loadDetail(this.sessionData.id);
      this.session = this.storeModule.currentSession;
      this.populateForm();
    }
  }

  stripPrefix(label: string) {
    return label ? label.replace(/^\d+\.\s*/, "") : "";
  }

  onCpChange() {
    const def = this.storeModule.definitions.find((d: any) => d.id === this.form.cp_definition_id);
    if (!def) return;

    // Pre-fill departemen_smf if empty
    if (!this.form.departemen_smf && def.departemen_smf) {
      this.form.departemen_smf = def.departemen_smf;
    }
    if (!this.form.diagnosis_icd10_kode && def.icd_kode) {
      this.form.diagnosis_icd10_kode = def.icd_kode;
    }
    if (!this.form.diagnosis_icd10_uraian && def.icd_nama) {
      this.form.diagnosis_icd10_uraian = def.icd_nama;
    }

    // Fill standar_cp for each komponen
    this.items.forEach((item: any) => {
      if (!item.standar_cp) {
        if (item.komponen === "los") {
          item.standar_cp = def.los_target_hari
            ? `LOS target: ${def.los_target_hari} hari sesuai CP ${def.nama_pathway}`
            : "-";
        } else {
          const fieldMap: any = {
            terapi: "komponen_terapi",
            penunjang: "komponen_penunjang",
            tindakan: "komponen_tindakan",
            diet: "komponen_diet",
            edukasi: "komponen_edukasi",
          };
          item.standar_cp = def[fieldMap[item.komponen]] || "-";
        }
      }
    });
  }

  openPicker() {
    // Default rentang 30 hari terakhir bila belum diisi
    if (!this.pickerFilter.date_to) {
      this.pickerFilter.date_to = moment().format("YYYY-MM-DD");
    }
    if (!this.pickerFilter.date_from) {
      this.pickerFilter.date_from = moment().subtract(30, "days").format("YYYY-MM-DD");
    }
    this.showPicker = true;
    this.loadCandidates();
  }

  async loadCandidates() {
    this.pickerLoading = true;
    try {
      const resp = await CpComplianceSvc.getPatientCandidates(this.pickerFilter);
      this.candidates = resp?.data?.status == "1" ? resp.data.data || [] : [];
    } catch {
      this.candidates = [];
    }
    this.pickerLoading = false;
  }

  async pickCandidate(row: any) {
    this.pickingId = row.register_id;
    await this.doLookup(row.register_id);
    this.pickingId = null;
    this.showPicker = false;
  }

  async doLookup(registerId: number) {
    if (!registerId) return;
    try {
      const resp = await CpComplianceSvc.lookupPatient(registerId);
      if (resp?.data?.status == "1") {
        const d = resp.data.data;
        this.form.register_id = d.register_id;
        this.form.pasien_rm = d.pasien_rm || "";
        this.form.pasien_nama = d.pasien_nama || "";
        this.form.unit_id = d.unit_id || "";
        this.form.dpjp_id = d.dpjp_id || null;
        this.form.dpjp_nama = d.dokter_nama || "";
        if (d.tgl_masuk) this.form.tgl_masuk = moment(d.tgl_masuk).format("YYYY-MM-DD");
        if (d.tgl_keluar) this.form.tgl_keluar = moment(d.tgl_keluar).format("YYYY-MM-DD");
        appModule.NoticeDelay("Data pasien berhasil dimuat");
      }
    } catch {
      // handled by ErrorAlert
    }
  }

  populateForm() {
    if (!this.session) return;
    const s = this.session;
    this.form = {
      cp_definition_id: s.cp_definition_id,
      register_id: s.register_id,
      pasien_rm: s.pasien_rm || "",
      pasien_nama: s.pasien_nama || "",
      dpjp_id: s.dpjp_id,
      dpjp_nama: s.dpjp_nama || "",
      unit_id: s.unit_id || "",
      departemen_smf: s.departemen_smf || "",
      tgl_evaluasi: s.tgl_evaluasi ? moment(s.tgl_evaluasi).format("YYYY-MM-DD") : "",
      tgl_masuk: s.tgl_masuk ? moment(s.tgl_masuk).format("YYYY-MM-DD") : "",
      tgl_keluar: s.tgl_keluar ? moment(s.tgl_keluar).format("YYYY-MM-DD") : "",
      diagnosis_icd10_kode: s.diagnosis_icd10_kode || "",
      diagnosis_icd10_uraian: s.diagnosis_icd10_uraian || "",
      persentase_kesesuaian: s.persentase_kesesuaian != null ? Number(s.persentase_kesesuaian) : null,
      is_eksklusi: s.is_eksklusi || false,
      varian_alasan: s.varian_alasan || "",
      jenis_varian: s.jenis_varian || null,
      analisa_penyebab: s.analisa_penyebab || [],
      penyebab_lainnya: s.penyebab_lainnya || "",
      rencana_tindak_lanjut: s.rencana_tindak_lanjut || "",
    };
    // Nilai tersimpan dianggap manual agar tak ditimpa watcher auto saat item dimuat.
    this.persentaseManual = true;
    if (s.items && s.items.length > 0) {
      for (const savedItem of s.items) {
        const local = this.items.find((i: any) => i.komponen === savedItem.komponen);
        if (local) {
          local.standar_cp = savedItem.standar_cp || "";
          local.realisasi_temuan = savedItem.realisasi_temuan || "";
          local.status_komponen = savedItem.status_komponen;
          local.keterangan_varian = savedItem.keterangan_varian || "";
        }
      }
    }
  }

  showWarning(message: string) {
    this.warningMessage = message;
    this.warningSnackbar = true;
  }

  /**
   * Validate all required fields client-side. Returns true if valid.
   * Shows warning snackbar with specific message if not.
   */
  validateBeforeSubmit(forSubmit: boolean): boolean {
    if (!this.form.tgl_evaluasi) {
      this.showWarning("Tanggal Evaluasi wajib diisi");
      return false;
    }
    if (!this.form.cp_definition_id) {
      this.showWarning("Clinical Pathway wajib dipilih");
      return false;
    }
    if (!this.form.register_id || !String(this.form.pasien_rm || "").trim()) {
      this.showWarning("No. Rekam Medis wajib diisi — silakan lookup pasien terlebih dahulu");
      return false;
    }

    if (!forSubmit) return true;

    // Submit requires all 6 items complete
    const unfilled = this.items.filter(
      (i: any) => !i.realisasi_temuan || !i.status_komponen
    );
    if (unfilled.length > 0) {
      this.showWarning(
        `Masih ada ${unfilled.length} komponen CP yang belum lengkap (realisasi & status wajib diisi)`
      );
      return false;
    }

    // Section D validation if tidak_patuh & not eksklusi
    const hasTidak = this.items.some((i: any) => i.status_komponen === "tidak_sesuai");
    if (hasTidak && !this.form.is_eksklusi) {
      if (!this.form.varian_alasan || !this.form.jenis_varian || !this.form.rencana_tindak_lanjut) {
        this.showWarning("Analisa Varian (Section D) wajib diisi untuk status TIDAK PATUH");
        return false;
      }
      if (!this.form.analisa_penyebab || this.form.analisa_penyebab.length === 0) {
        this.showWarning("Analisa Penyebab minimal 1 pilihan harus dicentang");
        return false;
      }
    }

    return true;
  }

  /**
   * Coerce form values to proper types expected by backend to avoid 422 on
   * null/undefined values from readonly fields.
   */
  buildPayload() {
    const trim = (v: any) => String(v || "").trim();
    return {
      cp_definition_id: this.form.cp_definition_id ? Number(this.form.cp_definition_id) : null,
      register_id: this.form.register_id ? Number(this.form.register_id) : null,
      pasien_rm: trim(this.form.pasien_rm),
      pasien_nama: trim(this.form.pasien_nama) || null,
      dpjp_id: this.form.dpjp_id ? Number(this.form.dpjp_id) : null,
      unit_id: trim(this.form.unit_id) || null,
      departemen_smf: trim(this.form.departemen_smf) || null,
      tgl_evaluasi: this.form.tgl_evaluasi || null,
      tgl_masuk: this.form.tgl_masuk || null,
      tgl_keluar: this.form.tgl_keluar || null,
      diagnosis_icd10_kode: trim(this.form.diagnosis_icd10_kode) || null,
      diagnosis_icd10_uraian: trim(this.form.diagnosis_icd10_uraian) || null,
      persentase_kesesuaian:
        this.form.persentase_kesesuaian === "" || this.form.persentase_kesesuaian === null
          ? null
          : Number(this.form.persentase_kesesuaian),
      is_eksklusi: !!this.form.is_eksklusi,
      varian_alasan: trim(this.form.varian_alasan) || null,
      jenis_varian: this.form.jenis_varian || null,
      analisa_penyebab: Array.isArray(this.form.analisa_penyebab) ? this.form.analisa_penyebab : [],
      penyebab_lainnya: trim(this.form.penyebab_lainnya) || null,
      rencana_tindak_lanjut: trim(this.form.rencana_tindak_lanjut) || null,
      items: this.items.map((i: any) => ({
        komponen: i.komponen,
        standar_cp: trim(i.standar_cp) || null,
        realisasi_temuan: trim(i.realisasi_temuan) || null,
        status_komponen: i.status_komponen || null,
        keterangan_varian:
          i.status_komponen === "tidak_sesuai" ? trim(i.keterangan_varian) || null : null,
      })),
    };
  }

  async simpanDraft() {
    if (!this.validateBeforeSubmit(false)) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.session?.id) {
        resp = await CpComplianceSvc.update(this.session.id, payload);
      } else {
        resp = await CpComplianceSvc.create(payload);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Draft berhasil disimpan");
        this.session = resp.data.data;
        this.$emit("saved");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async submitAndSign() {
    if (!this.validateBeforeSubmit(true)) return;

    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (!this.session?.id) {
        // Create first
        resp = await CpComplianceSvc.create(payload);
        if (resp?.data?.status == "1") {
          this.session = resp.data.data;
        } else {
          this.saving = false;
          return;
        }
      }
      resp = await CpComplianceSvc.submit(this.session.id, payload);
      if (resp?.data?.status == "1") {
        this.session = resp.data.data;
        this.showSignDialog = true;
      }
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async doSign() {
    if (!this.signPassword) {
      this.showWarning("Password wajib diisi");
      return;
    }
    this.signing = true;
    try {
      const resp = await CpComplianceSvc.signPpa(this.session.id, { password: this.signPassword });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menandatangani sebagai PPA");
        this.showSignDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.signing = false;
  }
}
